<template>
  <div class="page-content">
    <div class="d-flex align-items-center justify-content-center">
      <div class="row w-100 mx-0 auth-page">
        <div class="col-md-8 col-xl-6 mx-auto d-flex flex-column align-items-center">
          <img src="@/assets/images/undraw/lost-sign.svg" width="50%" class="img-fluid mb-2" alt="404">
          <h4 class="mb-2">Coming soon</h4>
          <h6 class="text-muted mb-3 text-center">
            Oopps!! We are preparing for a great update on this page, but it is not ready yet. So, please wait till it's ready 😉
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
  metaInfo: {
    title: 'Coming Soon',
  },
};
</script>
